module.exports = __webpack_public_path__ + "static/media/3.question_loop.64ab7397.mp4";